var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"el",staticClass:"d-flex justify-space-around align-center w-full"},_vm._l((_vm.dots || _vm.nOfDots),function(i){return _c('div',{key:`t-${i}`,staticClass:"dot",class:{ top: _vm.top, bottom: _vm.bottom },style:({
      backgroundColor: _vm.bgColor,
      width: `${_vm.size}px`,
      height: `${_vm.size}px`,
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }